/**
 * Maps a message type to an event name
 * @param messageType The message type to convert
 * @returns The corresponding event name
 */
export const getEventNameFromMessageType = (messageType: string): string => {
  switch (messageType) {
    case 'llm_thinking':
      return 'thinking_start';
    case 'llm_text':
      return 'text_start';
    case 'llm_tool':
      return 'tool_call';
    case 'llm_response':
      return 'response';
    default:
      return 'text_start'; // Default to text_start for unknown message types
  }
};
